<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/items/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ترتیب فایل {{ item.title }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <draggable-table :items="pluckedItemFiles" :headers="headers"
                             :key="draggableKey"
                             @sorted="sortItemFiles($event)"></draggable-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DraggableTable from "@/components/DraggableTable/DraggableTable";

export default {
  name: "ItemFileOrder",
  components: {DraggableTable},
  data() {
    return {
      item: null,
      ItemFiles: [],
      pluckedItemFiles: [],
      headers: [
        'شناسه',
        'عنوان',
        'نام دسته بندی',
        'ساخته شده در',
        'ترتیب',
        'نوع فایل',
        'حجم',
        'زمان',
        'نمایش',
        'وضعیت نمایش',
      ],
      draggableKey: 0
    }
  },
  methods: {
    getItemFiles() {
      this.pluckedItemFiles = [];
      window.axios.get('course/item/get-full-files/' + this.$route.params.id).then((res) => {
        this.ItemFiles = res.data.data.files
        this.item = res.data.data.item
        Object.values(this.ItemFiles).forEach((item) => {
          let pluckedItem = {
            id: item.id,
            title: item.title,
            category_name: item.category_name,
            created_at_fa: item.created_at_fa,
            order: item.pivot.order,
            mime_type: item.mime_type,
            size: item.size,
            duration: item.duration,
            view: item.file,
            visibility: item.visibility,
          }
          this.$set(this.pluckedItemFiles, this.pluckedItemFiles.length, pluckedItem)
          this.draggableKey += 1
        })
      })
    },
    sortItemFiles(ids) {
      window.axios.post('course/item/sort/' + this.$route.params.id, {
        file_ids: ids
      }).then(() => {
        this.getItemFiles()
      })
    }
  },
  mounted() {
    this.getItemFiles()
  }
}
</script>

<style scoped>

</style>